import { useSelector } from 'react-redux'
import rolesEnum from '@/constant/rolesEnum'

const useHideStudentsPersonalDataForTeacher = () => {
  return useSelector(
    (store: any) => {
      const role = store.profile?.profile?.role

      return (
        [rolesEnum.seminarian, rolesEnum.seniorSeminarian].includes(role) &&
        store.settings?.isHideStudentsPersonalDataInTeacherReports === '1'
      )
    },
  )
}

export default useHideStudentsPersonalDataForTeacher
